/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');
import {get_work_days_from_workweek} from "../../global/functions";

'use strict';

class OrganisationDetailController {
    public trialEnabled = false;
    public trialEmployeeOwnEdit = false;
    public maxPageItems = 20;
    public crtPage = 1;
    public first_edit = true;
    public editing = false;
    public editing_new = false;
    public number_of_active_employees = 0;
    public form_models: any = {};
    public employeeAssignments = [];

    public isHelping = false;
    public showOverlayCallOuts = false;
    public isCurrent = -1;

    public defaultWeekStartValue = 'Sunday';
    public defaultWeekEndValue = 'Monday';

    public officeIndex = undefined;
    public divisionIndex = undefined;
    public divisiondocIndex = undefined;
    public departmentIndex = undefined;
    public licenceIndex = undefined;
    public documentIndex = undefined;
    public benefitIndex = undefined;
    public benefitdocIndex = undefined;

    public safe_hands_file_types = ["CPR Course", "Fit for Work"];

    public changeTab = 0;
    public currentStep = 1;
    public columns = [];
    public officeObject = [];
    public currentOfficeArray = []
    public currentOffice = {
        name: '',
        description: '',
        address: '',
        country: '',
        manager: undefined
    };

    public currentDivision = {
        name: '',
        description: '',
        manager: undefined,
        convertedSuperior: undefined,
        departments: []
    };

    public currentDepartment = {
        name: '',
        description: '',
        convertedSuperior: undefined,
        manager: undefined
    };

    public currentLicence = {
        name: '',
        registration_type: '',
        description: '',
        expiry_date: '',
        file: '',
        fileName: ''
    };

    public currentDocument = {
        title: '',
        description: '',
        expiryDate: '',
        file: '',
        fileName: ''
    };

    public currentLeaveObject = {
        paidLeave: '',
        sickLeave: '',
        maternityLeave: '',
        paternityLeave: '',
        carriedForward: '',
        carriedForwardNextYear: false,
        workWeekStart: '',
        workWeekEnd: ''
    };

    public currentBenefit = {
        name: '',
        description: ''
    };

    public currentBenfitDoc = {
        title: '',
        description: '',
        file: ''
    };

    public detailsActiveEmployees = [];
    public detailsIndustry = [];
    public detailsCurrency = [];
    public wpsFormats = ['CSV', 'TXT'];
    public wpsFormat = this.wpsFormats[0];
    public wpsStartDate = moment().format("YYYY-MM-01");
    public wpsEndDate = moment().format("YYYY-MM-") + moment().daysInMonth();
    public wpsStartDateStr = this.wpsStartDate;
    public wpsEndDateStr = this.wpsEndDate;
    public wpsFile = null;
    public wps_employees = [];
    public wpsImportStep = 0;
    public wpsImportData;
    public wpsDone = false;
    public wpsSuccess = false;


    public payroll_mode = 0;
    public licenceType = [];
    public officeCountry = [];
    public weekDays = [];
    public workDayRanges = [
        'Sunday to Thursday',
        'Sunday to Thursday (half-day)',
        'Monday to Friday',
        'Monday to Friday (half-day)',
        'Custom'
    ];
    public workDayOption = null;

    public workWeekList = [];

    public fixedSalaryRanges = [
        'Basic Salary',
        'Total Salary'
    ];

    public variableSalaryRanges = [
        'Nothing',
        'Count allowances'
    ]
    public fixedSalaryValue = this.fixedSalaryRanges[0];
    public variableSalaryValue = this.variableSalaryRanges[0];

    public inlineApiData = {
        id: '',
        fieldName: '',
        currentValue: '',
        newValue: '',
        dataVersionId: ''
    };

    public defaultValue = '---';
    public isTour;

    public docObj = {
        number: this.defaultValue,
        expiryDate: this.defaultValue,
        reportDate: this.defaultValue,
        file: this.defaultValue,
        name: this.defaultValue,
        type: this.defaultValue,
    };

    public fileDirModel = {
        fileName: 'Select a file',
        fileLink: undefined
    };
    public medicalDocObj = {
        name: this.defaultValue,
        reportDate: this.defaultValue,
        file: this.defaultValue,
        action: ''
    };

    public docTypeLogo = 'orgLogo';
    public employeeSelectList = [];

    public employeeSelectListInsurance = [];

    public new_office = {
        name: '',
        description: '',
        country: '',
        address: '',
        manager: undefined
    };
    public new_division = {
        name: '',
        description: '',
        manager: undefined
    };
    public new_department = {
        name: '',
        description: '',
        manager: undefined
    };
    public new_bl_doc = '';
    public new_bl = {
        name: '',
        type: '',
        expiryDate: '',
        description: '',
    };
    public new_office_doc = {
        title: '',
        description: '',
        file: '',
        expiryDate: ''
    };
    public new_benefit = {
        name: '',
        description: ''
    };
    public new_benefit_doc = {
        title: '',
        description: '',
        file: '',
    };

    public new_logo: boolean = false;

    public working_weeks = [{
      id: null,
      description: "Default",
      startDay: '',
      endDay: '',
      halfDay: false
    },]

    public benefitAssignmentsList = [];
    public benefitAssignmentsMap = {};
    public structureAssignmentsMap = {};

    public static $inject = [
        '$http',
        '$scope',
        '$state',
        '$stateParams',
        '$uibModal',
        'Api',
        'bsLoadingOverlayService',
        'Employee',
        '$timeout',
        'Orgs',
        'toaster',
        'Upload',
        'User',
        '$q',
    ];

    public currentDetails = {
        canEnrollInTrial: false,
        organisationName: '',
        image: '',
        webSiteUrl: '',
        industry: '',
        numberOfEmployees: '',
        contactAddress: '',
        contactEmail: '',
        insuranceContacts: [],
        contactPhoneNumber: '',
        currency: '',
        workHoursStart: '',
        workHoursEnd: '',
        leaveAnnualStartDate: '',
        contactforAdditionServices: '',
        trackDependantsOnCompanyProgram: false,
        trackDependantsOffCompanyProgram: false,
        canEditPersonal: false,
        hubspotSignUp: false,
    };

    public org_id;
    public pageNums;
    public first;
    public act;
    public org;
    public user;
    public hasPermission;
    public schema;
    public titles;

    public defs;

    public convertedTimeStart;
    public convertedTimeEnd;
    public convertedSuperior;

    public details;
    public processes;
    public office;
    public office_document;
    public division;
    public department;
    public business_licence;
    public benefit;
    public benefit_document;
    public ExternalUrl;
    public employee;
    public terminate_reason;
    public terminate_date;
    public from;
    public selected;
    public datePickerConfig;
    public employees = [];
    public lemployees = [];
    public names = [];
    public marketing = [];

    private empEventName: string;
    private empEventAddData: string;
    fix_this_description: any;

    constructor(
        private $http: angular.IHttpService,
        private $scope: angular.IScope,
        private $state: ng.ui.IStateService,
        private $stateParams: any,
        private $uibModal: any,
        private Api: any,
        private bsLoadingOverlayService: IBsLoadingService,
        private Employee: IEmpService,
        private $timeout: ng.ITimeoutService,
        private Orgs: IOrgsService,
        private toaster: toaster.IToasterService,
        private Upload: any,
        private User: IUserService,
        private $q: angular.IQService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.org_id = this.$stateParams.id || undefined;
        this.hasPermission = User.hasPermission;
        this.$uibModal = $uibModal;

        this.first = this.$stateParams.first || false;
        this.from = this.$stateParams.from || false;

        this.act = functions.act;
        this.ExternalUrl = functions.ExternalUrl;

        this.defs = {
            org: {
                update: (f) => {
                    this.org.name = f({name: this.org.name}).name;
                }
            },
            image: {
                update: (f) => {
                    this.org.extra.image = f(this.org.extra.image);
                }
            },
            leave: {
                update: (f) => {
                    this.org.extra.leave = f(this.org.extra.leave || {});
                }
            },
            details: {
                other: ['org', 'image']
            },

            marketing: {
                update: (f) => {
                    this.org.extra.marketing.lead_capture = f(this.org.extra.marketing.lead_capture || false);
                }
            },

            processes: {
                other: ['leave']
            },

            offices: {
                deselect: () => {
                    this.office = undefined;
                    this.division = undefined;
                    this.department = undefined;
                    this.business_licence = undefined;
                }
            },

            office: {
                form: ['name', 'description', 'country', 'address', 'manager'],
                deselect: () => {
                    this.division = undefined;
                    this.department = undefined;
                    this.business_licence = undefined;
                    this.office_document = undefined;
                },
                update_list: (f) => {
                    this.org.extra.offices = f(this.org.extra.offices || []);
                    this.newNavigateOffice();
                }
            },

            business_licence: {
                form: ['name', 'registration_type', 'description'],
                update_list: (f) => {
                    this.office.business_licences = f(this.office.business_licences || []);
                }
            },

            office_document: {
                update_list: (f) => {
                    this.office.documents = f(this.office.documents || []);
                }
            },

            division: {
                form: ['name', 'description', 'manager'],
                deselect: () => {
                    this.department = undefined;
                    this.business_licence = undefined;
                    this.office_document = undefined;
                },

                update_list: (f) => {
                    this.office.divisions = f(this.office.divisions || []);
                }
            },

            department: {
                update_list: (f) => {
                    this.division.departments = f(this.division.departments || []);
                }
            },

            benefit: {
                form: ['name', 'description'],
                deselect: () => {
                    this.benefit_document = undefined;
                },

                update_list: (f) => {
                    this.org.extra.benefits = f(this.org.extra.benefits || []);
                }
            },

            benefits: {
                deselect: () => {
                    this.benefit = undefined;
                    this.benefit_document = undefined;
                }
            },

            benefit_document: {
                update_list: (f) => {
                    this.benefit.documents = f(this.benefit.documents || []);
                }
            }
        };

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false
        };

        this.loadOrg();

        Orgs.loadSchema()
            .then((response: any) => {
                    this.schema = response.data;
                    this.detailsActiveEmployees = this.schema.properties.details.properties.number_of_employees.enum;
                    this.detailsIndustry = this.schema.properties.details.properties.industry.enum;
                    this.detailsCurrency = this.schema.properties.details.properties.currency.enum;
                    this.licenceType = this.schema.properties.offices.items.properties.business_licences.items.properties.registration_type.enum;
                    this.officeCountry = this.schema.properties.offices.items.properties.country.enum;
                    this.weekDays = this.schema.properties.leave.properties.work_week_start.enum;
                    this.titles = Orgs.getTitlesBySchema(this.schema, '', {});
                    this.checkLoading();
                }
            );

        Employee.allNonEmployees(this.org_id)
            .then(response => {
                    this.employees = response;
                    for (let i: number = 0; i < this.employees.length; i++) {
                        let employee: any = {
                            id: this.employees[i].id,
                            name: this.employees[i].displayname
                        };
                        this.employeeSelectList.push(employee);

                    }
                    this.checkLoading();
                }
            );

        this.loadEmployees();
        this.user = this.User.getCurrentUser();
        if (!this.user.isSuperUser) {
            this.Employee.loadEmployee(User.getCurrentUser().userData.id)
                .then((response: Restangular.IResponse) => {
                        this.isTour = this.Employee.getCoTourStatus();
                        let hasVisited: boolean = false;
                        this.employee = response;
                        let list: any = this.employee.extra.help_boxes_visited;
                        for (let i: number = 0; i < list.length; i++) {
                            if (list[i] === 3) {
                                hasVisited = true;
                            }
                        }

                        

                        if (!hasVisited) {
                            this.startCallouts();
                        } else if (this.isTour === true) {
                            this.startCallouts();
                        }
                    }
                );
        }
        $scope.$emit('$pageWithHelpVisited', 3);
    }

    public loadEmployees = function (page: number = 1): void {
        this.crtPage = page;
        this.lemployees = [];
        this.bsLoadingOverlayService.start({
            referenceId: 'loader'
        });

        this.Employee.allEmployees(this.org_id, page)
            .then(response => {
                    this.lemployees = response.results;
                    this.createInsuranceList(this.lemployees);
                    for (let i: number = 0; i < this.lemployees.length; i++) {
                        let employee: any = {
                            id: this.lemployees[i].id,
                            name: this.lemployees[i].displayname
                        };

                        this.employeeSelectList.push(employee);
                    }

                    this.lemployees.count = response.count;
                    this.pageNums = new Array(Math.ceil(this.lemployees.count / this.maxPageItems));
                    if (this.Employee.getQuery() !== '' && this.lemployees.count + this.employees.count === 0) {
                        this.toaster.pop(
                            'warning',
                            'Warning',
                            'No results matched the search term: ' + this.Employee.getQuery()
                            + '. Please try to use a different keyword.'
                        );
                    }

                    this.checkLoading();
                    this.bsLoadingOverlayService.stop({
                        referenceId: 'loader'
                    });
                }
            );

        this.names = [];
        this.Employee.names('', this.org_id)
            .then((names) => {
                    this.names = names;
                    this.checkLoading();
                }
            );

        this.employeeAssignments = [];
        this.Employee.allEmployeesAssignments(this.org_id).then((response) => {
            this.employeeAssignments = response;
            this.checkLoading();
        });
    };

    public createInsuranceList = function (employeeList: object[]): void {
        this.employeeSelectListInsurance = employeeList.map((empl) => {
            const { 
                id,
                displayname,
                user: {
                    email = '',
                } = {},
            } = empl as any;
            return {
                id,
                email,
                name: displayname,
            }
        });
    }

    public loadOrg(): void {
        this.bsLoadingOverlayService.start({
            referenceId: 'loader'
        });

        this.Orgs.getOrg(this.org_id)
            .then((response: Restangular.IResponse) => {
                    this.org = response;
                    if (!this.org.extra.details) {
                        this.org.extra.details = {};
                    }

                    if (!this.org.extra.leave) {
                        this.org.extra.leave = {};
                    }

                    if (!this.org.extra.trial) {
                        this.org.extra.trial = {
                            enrolled: false,
                            can_select: false
                        }
                    }
                    this.trialEnabled = this.org.extra.trial.enrolled;

                    this.trialEmployeeOwnEdit = this.org.extra.details.employee_can_edit_personal || false;

                    if (this.org.extra.image) {
                        this.fileDirModel.fileName = this.parseFileName(this.org.extra.image);
                    }

                    if (this.org.extra.leave.annual_cycle_start_date === undefined) {
                        this.org.extra.leave.annual_cycle_start_date = '2020-01-01';
                    }

                    // Handle work week ranges
                    let workDays = functions.get_work_days(this.org);
                    let workDayEndHalf = !!this.org.extra.leave.work_week_end_half_day;
                    this.workDayOption = null;

                    // Check for known values for work days to map to range drop-down
                    if (workDays.length == 5) {
                        if (workDays[0] == 0 && workDays[4] == 4) {
                            this.workDayOption = workDayEndHalf ? this.workDayRanges[1] :  this.workDayRanges[0];
                        } else if (workDays[0] == 1 && workDays[4] == 5) {
                            this.workDayOption = workDayEndHalf ? this.workDayRanges[3] : this.workDayRanges[2];
                        }
                    }

                    if (!this.workDayOption) {
                        this.workDayOption = this.workDayRanges[4];
                    }

                    if (this.org.extra.details.work_hours_start !== undefined) {
                        let StartTime: Date = new Date(
                            '1970-01-01T' + this.org.extra.details.work_hours_start
                        );
                        let MomentStartTime: Moment = moment(StartTime);
                        this.convertedTimeStart = MomentStartTime;
                    }

                    if (this.org.extra.details.work_hours_end !== undefined) {
                        let EndTime: Date = new Date(
                            '1970-01-01T' + this.org.extra.details.work_hours_end
                        );
                        let MomentEndTime: Moment = moment(EndTime);
                        this.convertedTimeEnd = MomentEndTime;
                    }

                    if (this.org.extra.marketing === undefined) {
                        this.org.extra.marketing = {'lead_capture': false};
                    }

                    this.form_models.marketing = this.org.extra.marketing;
                    this.form_models.leave = this.org.extra.leave;
                    if (this.org.extra.image) {
                        this.form_models.image = this.org.extra.image;
                    }

                    // make sure new annual leave config has a valid value
                    if (this.org.extra.leave === undefined) {
                        this.org.extra.leave = {};
                    }

                    if (this.org.extra.insurance === undefined) {
                        this.org.extra.insurance = {
                            insurance_contacts: [],
                        };
                    }
                    this.details = this.org.extra.details;
                    this.processes = this.org.extra.processes || {};
                    if (!this.processes.document) {
                        this.processes.document = {};
                    }
                    if (!this.processes.payroll_allowances) {
                        this.processes.payroll_allowances = [];
                    }
                    if (!this.processes.payroll_deductions) {
                        this.processes.payroll_deductions = [];
                    }

                    // assign default values
                    this.number_of_active_employees = this.org.number_of_active_employees;
                    this.currentLeaveObject = {
                        paidLeave: this.org.extra.leave.paid_leave_days_per_year || this.defaultValue,
                        sickLeave: this.org.extra.leave.sick_leave_days_per_year || this.defaultValue,
                        maternityLeave: this.org.extra.leave.maternity_leave_days_per_year || this.defaultValue,
                        paternityLeave: this.org.extra.leave.paternity_leave_days_per_year || this.defaultValue,
                        carriedForward: this.org.extra.leave.carried_forward || this.defaultValue,
                        carriedForwardNextYear: this.org.extra.leave.show_next_year_carried_forward || false,
                        workWeekStart: this.org.extra.leave.work_week_start || this.defaultWeekStartValue,
                        workWeekEnd: this.org.extra.leave.work_week_end || this.defaultWeekEndValue
                    };

                    // assign default values
                    this.currentDetails = {
                        canEnrollInTrial: this.org.extra.trial.can_select || false,
                        organisationName: this.org.name || this.defaultValue,
                        image: this.org.extra.image || '',
                        webSiteUrl: this.org.extra.details.url || this.defaultValue,
                        industry: this.org.extra.details.industry || this.defaultValue,
                        numberOfEmployees: this.org.extra.details.number_of_employees || this.defaultValue,
                        contactAddress: this.org.extra.details.contact_address || this.defaultValue,
                        contactEmail: this.org.extra.details.contact_email || this.defaultValue,
                        insuranceContacts: this.org.extra.insurance.insurance_contacts || [],
                        contactPhoneNumber: this.org.extra.details.contact_phone || this.defaultValue,
                        currency: this.org.extra.details.currency || this.defaultValue,
                        workHoursStart: this.org.extra.details.work_hours_start || this.defaultValue,
                        workHoursEnd: this.org.extra.details.work_hours_end || this.defaultValue,
                        leaveAnnualStartDate: this.org.extra.leave.annual_cycle_start_date || this.defaultValue,
                        contactforAdditionServices: this.org.extra.marketing.lead_capture || this.defaultValue,
                        trackDependantsOnCompanyProgram: this.org.extra.details.track_dependants_visa_on_company_program || false,
                        trackDependantsOffCompanyProgram: this.org.extra.details.track_dependants_visa_off_company_program || false,
                        canEditPersonal: this.org.extra.details.employee_can_edit_personal || false,
                        hubspotSignUp: false,
                    };

                    if (!this.org.extra.ohs) {
                        this.org.extra.ohs = {
                            type: 'None Currently'
                        };
                    }

                    // Payroll SIF
                    if (!this.org.extra.payroll) {
                        this.org.extra.payroll = {
                            formatDefined: false
                        }
                    }

                    this.checkLoading();
                }
            );
    }

    private checkLoading(): void {
        if (this.schema && this.org && this.names && this.employees && this.employeeAssignments) {
            if (!this.org.extra.details) {
                this.org.extra.details = {};
                this.details = this.org.extra.details;
            }

            if (!this.org.extra.benefits) {
                this.org.extra.benefits = [];
            }

            if (!this.org.extra.offices) {
                this.org.extra.offices = [];
            }

            if (!this.org.extra.processes) {
                this.org.extra.processes = {};
            }
            this.processes = this.org.extra.processes;

            if (!this.processes.document) {
                this.processes.document = {};
            }
            if (!this.processes.payroll_allowances) {
                this.processes.payroll_allowances = [];
            }
            if (!this.processes.payroll_export) {
                this.processes.payroll_export = {
                    fixed_salary_allowances: false,
                    variable_salary_allowances: false
                };
            }

            // Preload the wps export settings
            if (this.processes.payroll_export.fixed_salary_allowances) {
                this.fixedSalaryValue = this.fixedSalaryRanges[1];
            } else {
                this.fixedSalaryValue = this.fixedSalaryRanges[0];
            }

            if (this.processes.payroll_export.variable_salary_allowances) {
                this.variableSalaryValue = this.variableSalaryRanges[1];
            } else {
                this.variableSalaryValue = this.variableSalaryRanges[0];
            }

            // Setup work week mappings
            this.workWeekList.length = 0;
            let workWeekMap = {};

            let workWeek = {
                id: null,
                name: 'Default',
                startDay: this.org.extra.leave.work_week_start,
                endDay: this.org.extra.leave.work_week_end,
                endHalfDay: this.org.extra.leave.work_week_end_half_day,
                assigned_employees: []
            };
            workWeekMap[workWeek.name] = workWeek;
            this.workWeekList.push(workWeek)

            if (this.org.extra.leave.work_weeks) {
                for (const _workWeek of this.org.extra.leave.work_weeks) {
                    workWeek = {
                        id: this.workWeekList.length,
                        name: _workWeek.description,
                        startDay: _workWeek.work_week_start,
                        endDay: _workWeek.work_week_end,
                        endHalfDay: _workWeek.work_week_end_half_day,
                        assigned_employees: []
                    }
                    workWeekMap[workWeek.name] = workWeek;
                    this.workWeekList.push(workWeek)                }
            }

            // Setup benefits mappings
            this.benefitAssignmentsList = [];
            this.benefitAssignmentsMap = {};

            for (let benefit of this.org.extra.benefits) {
                let benefitAssignment = {
                    id: benefit.name,
                    index: this.benefitAssignmentsList.length,
                    assigned_employees: []
                }

                this.benefitAssignmentsList.push(benefitAssignment);
                this.benefitAssignmentsMap[benefit.name] = benefitAssignment
            }

            // Setup structure assignments
            this.structureAssignmentsMap = {};
            if (this.org.extra.offices) {
                for (let office of this.org.extra.offices) {
                    this.structureAssignmentsMap[office.name] = {};
                    if (office.divisions) {
                        for (let division of office.divisions) {
                            this.structureAssignmentsMap[office.name][division.name] = {};
                            if (division.departments) {
                                for (let department of division.departments) {
                                    this.structureAssignmentsMap[office.name][division.name][department.name] = [];
                                }
                            }
                        }
                    }
                }
            }

            // Count the number of employee assignments
            for (const emp of this.employeeAssignments) {
                // Count working week
                let workWeekIndex = emp.assignments.work_week_index || 'Default';
                try {
                    workWeek = workWeekMap[workWeekIndex];
                    workWeek.assigned_employees.push(emp);
                } catch (e) {
                    //console.log(e);
                }

                // Count benefits
                for (let empBenefit of emp.assignments.benefits) {
                    try {
                        this.benefitAssignmentsMap[empBenefit].assigned_employees.push(emp);
                    } catch (e) {

                    }
                }

                // Count structure

                if (emp.office && emp.division && emp.department) {
                    try {
                        this.structureAssignmentsMap[emp.office][emp.division][emp.department].push(emp);
                    } catch (e) {
                        // console.log(e);
                    }
                }
            }

            if (this.first && this.first_edit) {
                this.act('edit', 'details', this.org.extra.details);
                this.first_edit = false;
            }
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        }
    }

    private get_name(id: string): string {
        const displayName: string = (
            (this.names || [])
                .filter(
                    (e) => e.id === id)[0] || ''
        ).displayname;
        return displayName;
    }

    private has_clearance(clearance: any): (employee: any) => boolean {
        return (employee) => {
            return employee.user.clearance === clearance;
        };
    }

    public delete_modal(what: any, obj: any): void {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance',
                function ($scope: any, $uibModalInstance: any): void {
                    $scope.C = that;
                    $scope.what = what;
                    $scope.obj = obj;
                }],

            templateUrl: '/static/templates/organization/delete_modal.html'
        });
        this.new_logo = false;
        modalInstance.result.then(() => {
            switch (what) {
                case 'office':
                    this.emitEvent('org.offices.delete');
                    break;
                default:
                    this.emitEvent('org.offices.' + what + '.delete');
                    break;
            }
            this.act('delete', what, obj);
        });
    }

    public activate_employee_modal(employee: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = employee.displayname;
                    $scope.modalDetail = 'This employee will be re-instated and marked as active. Are you sure?';
                    $scope.confirmButton = 'Activate Employee';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({
                    referenceId: 'loader'
                });

                this.Employee.loadEmployee(employee.id)
                    .then((employeeResponse: Restangular.IResponse) => {
                        this.employee = employeeResponse;
                        this.Employee.activate(this.employee).then(() => {
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                                this.Employee.allNonEmployees(this.org_id)
                                    .then(response => {
                                            this.employees = response;
                                            this.checkLoading();
                                        }
                                    );

                                this.loadEmployees();
                                this.toaster.pop(
                                    'success',
                                    'Success',
                                    'Employee activated successfully.'
                                );
                            },
                            () => {
                                this.bsLoadingOverlayService.stop({
                                    referenceId: 'loader'
                                });

                                this.toaster.pop(
                                    'error',
                                    'Error',
                                    'There was an error processing your request'
                                );
                            });
                    });
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }


    public terminate_employee_modal(employee: any): void {
        const that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.confirmation = false;
                    $scope.modalHeader = employee.displayname;
                    $scope.modalDetail = 'This employee will be terminated and marked as inactive. Are you sure?';
                    $scope.confirmButton = 'Terminate Employee';
                    $scope.cancelButton = 'Cancel';
                    $scope.terminate_reason = '';
                    $scope.terminate_date = '';
                    $scope.datePickerConfig = that.datePickerConfig;
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_reason_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({
                    referenceId: 'loader'
                });

                this.Employee.loadEmployee(employee.id)
                    .then((employeeResponse: Restangular.IResponse) => {
                        this.employee = employeeResponse;
                        this.Employee.terminate(
                            this.employee,
                            that.terminate_reason,
                            moment(that.terminate_date).format('YYYY-MM-DD')
                        ).then(() => {
                                this.bsLoadingOverlayService.stop({
                                    referenceId: 'loader'
                                });

                                this.Employee.allNonEmployees(this.org_id).then(response => {
                                    this.employees = response;
                                    this.checkLoading();
                                });

                                this.loadEmployees();
                                this.toaster.pop(
                                    'success',
                                    'Success',
                                    'Employee terminated successfully.'
                                );
                            },
                            (response) => {
                                this.bsLoadingOverlayService.stop({
                                    referenceId: 'loader'
                                });

                                this.toaster.pop(
                                    'error',
                                    'Error',
                                    response.data
                                );
                            });
                    });
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Termination cancelled by user'
                );
            }
        });
    }

    public edit_employee_modal(employee: any): void {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.employee = employee;
                    $scope.employee.user.clearance = employee.user.clearance;
                    $scope.employee.extra.personal.first_name = employee.extra.personal.first_name;
                    $scope.employee.extra.personal.last_name = employee.extra.personal.last_name;
                    $scope.employee.user.email = employee.user.email;
                    $scope.ok = () => {
                        that.bsLoadingOverlayService.start({referenceId: 'loader'});
                        $scope.employee.extra.personal.contact.work.email = $scope.employee.user.email;
                        that.Employee.updateData(employee.id, $scope.employee, that.org_id).then((response: any) => {
                                that.toaster.pop('success', 'Success', 'Saved');
                                that.bsLoadingOverlayService.start({referenceId: 'loader'});
                                that.Employee.allNonEmployees(that.org_id)
                                    .then(emolyeesResponse => {
                                            that.employees = emolyeesResponse;
                                        }
                                    );

                                that.loadEmployees();
                                $uibModalInstance.close();
                            },
                            (response: any) => {
                                if (response.status === 400) {
                                    that.toaster.pop('error', 'Validation Failed', response.data);
                                } else {
                                    that.toaster.pop('error', 'Server Error', response.data.detail);
                                }

                                $uibModalInstance.close();
                            });
                    };

                    $scope.cancel = () => {
                        that.toaster.pop('warning', 'Cancelled', 'No changes were made. Cancelled by user.');
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            templateUrl: '/static/templates/employee/employee_edit_modal.html'
        });
        modalInstance.result.then(() => {
            this.loadEmployees();
        });
    }

    public login_employee(employee: any): void {
        window.location.href = '/api/auth/login_as?username=' + encodeURIComponent(employee.user.email);
    }

    /**
     * Parse filename from url
     * @param  {string} input [url from service]
     * @return {string}       [filename parsed]
     */
    public parseFileName(input: any): string {
        if (!_.isEmpty(input)) {
            return decodeURI(
                input.substring(
                    input.lastIndexOf('/') + 1
                )
            );
        }

        return '';
    }
    public getWorkWeekOption = (workWeek) => {
        let workDays = functions.get_work_days_from_workweek(workWeek);
        let workDayEndHalf = workWeek.endHalfDay;
        let workDayOption = null;
        // Check for known values for work days to map to range drop-down
        if (workDays.length == 5) {
            if (workDays[0] == 0 && workDays[4] == 4) {
                workDayOption = workDayEndHalf ? this.workDayRanges[1] :  this.workDayRanges[0];
            } else if (workDays[0] == 1 && workDays[4] == 5) {
                workDayOption = workDayEndHalf ? this.workDayRanges[3] : this.workDayRanges[2];
            }
        }

        // Must be a custom work week
        if (!workDayOption) {
            workDayOption = this.workDayRanges[4];
        }

        return workDayOption;
    }
    public getWorkWeekEndHalfDay = (workWeek, workWeekOption) => {
        // Return the week's half day setting if a custom work week
        if (workWeekOption == this.workDayRanges[4]) {
            return workWeek.endHalfDay;
        }

        return workWeekOption == this.workDayRanges[1] || workWeekOption == this.workDayRanges[3] ;
    }

    public assignWorkWeek = (workWeekIndex: string) => {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.work_week = {...that.workWeekList[workWeekIndex]};
                    $scope.work_week_index = workWeekIndex;
                    $scope.work_week_option = that.getWorkWeekOption($scope.work_week);
                    $scope.work_week_end_half_day = that.getWorkWeekEndHalfDay($scope.work_week, $scope.work_week_option);
                    $scope.employees = that.employeeAssignments;
                    $scope.assignments = {

                    }

                    for (const emp of $scope.employees) {
                        $scope.assignments[emp.id] = emp.assignments.work_week_index == workWeekIndex;
                        if (workWeekIndex == 'Default' && emp.assignments.work_week_index === null) {
                            $scope.assignments[emp.id] = true;
                        }
                    }

                    $scope.assignments_prev = {...$scope.assignments};

                    $scope.ok = () => {
                        //
                        let assignments = {
                            work_week_index: []
                        }
                        for (const emp of $scope.employees) {
                            let oldValue = $scope.assignments_prev[emp.id];
                            let newValue = $scope.assignments[emp.id];
                            if (oldValue != newValue) {
                                // Patch the employee
                                assignments.work_week_index.push({
                                    emp_id: emp.id,
                                    value: newValue ? workWeekIndex : null
                                })
                            }
                        }

                        if (assignments.work_week_index.length) {
                            that.bsLoadingOverlayService.start({referenceId: 'loader'});

                            that.Employee.updateAssignments(assignments).then(() => {
                                that.employeeAssignments = [];
                                that.Employee.allEmployeesAssignments(that.org_id).then((response) => {
                                    that.employeeAssignments = response;
                                    that.checkLoading();
                                });
                                that.toaster.pop('success', 'Saved');

                            })
                        }
                        $uibModalInstance.dismiss();

                    };

                    $scope.cancel = () => {
                        that.toaster.pop('warning', 'Cancelled', 'No changes were made. Cancelled by user.');
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            templateUrl: '/static/templates/organization/workweek_assignment_modal.html'
        });
        modalInstance.result.then(() => {
        });
    }

    public assignBenefits = (benefitIndex: number) => {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.benefit = that.org.extra['benefits'][benefitIndex];
                    $scope.benefit_name = $scope.benefit.name;
                    $scope.benefit_description = $scope.benefit.description;
                    $scope.employees = that.employeeAssignments;
                    $scope.assignments = {

                    }

                    let benefitId = that.benefitAssignmentsList[benefitIndex].id;

                    for (const emp of $scope.employees) {
                        $scope.assignments[emp.id] = emp.assignments.benefits.indexOf(benefitId) >= 0;
                    }
                    $scope.assignments_prev = {...$scope.assignments};

                    $scope.ok = () => {
                        let assignments = {
                            benefits: [],
                            benefitId: benefitId
                        }

                        for (const emp of $scope.employees) {
                            let oldValue = $scope.assignments_prev[emp.id];
                            let newValue = $scope.assignments[emp.id];
                            if (oldValue != newValue) {
                                assignments.benefits.push({
                                    emp_id: emp.id,
                                    value: newValue
                                })
                            }
                        }

                        if (assignments.benefits.length) {
                            that.bsLoadingOverlayService.start({referenceId: 'loader'});

                            that.Employee.updateAssignments(assignments).then(() => {
                                that.employeeAssignments = [];
                                that.Employee.allEmployeesAssignments(that.org_id).then((response) => {
                                    that.employeeAssignments = response;
                                    that.checkLoading();
                                });
                                that.toaster.pop('success', 'Saved');

                            })
                        }
                        $uibModalInstance.dismiss();

                    };

                    $scope.cancel = () => {
                        that.toaster.pop('warning', 'Cancelled', 'No changes were made. Cancelled by user.');
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            templateUrl: '/static/templates/organization/benefits_assignment_modal.html'
        });
        modalInstance.result.then(() => {
        });
    }

    public assignDepartment = (officeIndex: number, divisionIndex: number, departmentIndex: number) => {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.office = that.org.extra.offices[officeIndex];
                    $scope.division = $scope.office.divisions[divisionIndex];
                    $scope.department = $scope.division.departments[departmentIndex];
                    $scope.employees = that.employeeAssignments;
                    $scope.assignments = {

                    }

                    for (const emp of $scope.employees) {
                        if (!emp.assignments.structure.department) {
                            $scope.assignments[emp.id] = false;
                        } else {
                            $scope.assignments[emp.id] =
                                emp.assignments.structure.office == $scope.office.name &&
                                emp.assignments.structure.division == $scope.division.name &&
                                emp.assignments.structure.department == $scope.department.name;

                        }
                    }

                    $scope.assignments_prev = {...$scope.assignments};

                    $scope.ok = () => {
                        let assignments = {
                            structure: []
                        }
                        for (const emp of $scope.employees) {
                            let oldValue = $scope.assignments_prev[emp.id];
                            let newValue = $scope.assignments[emp.id];
                            if (oldValue != newValue) {
                                let structure = {

                                }
                                if (newValue) {
                                    structure['office'] = $scope.office.name;
                                    structure['division'] = $scope.division.name;
                                    structure['department'] = $scope.department.name;
                                }
                                // Patch the employee
                                assignments.structure.push({
                                    emp_id: emp.id,
                                    value: newValue = structure
                                })
                            }
                        }

                        if (assignments.structure.length) {
                            that.bsLoadingOverlayService.start({referenceId: 'loader'});

                            that.Employee.updateAssignments(assignments).then(() => {
                                that.employeeAssignments = [];
                                that.Employee.allEmployeesAssignments(that.org_id).then((response) => {
                                    that.employeeAssignments = response;
                                    that.checkLoading();
                                });
                                that.toaster.pop('success', 'Saved');

                            })
                        }
                        $uibModalInstance.dismiss();

                    };

                    $scope.cancel = () => {
                        that.toaster.pop('warning', 'Cancelled', 'No changes were made. Cancelled by user.');
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            templateUrl: '/static/templates/organization/department_assignment_modal.html'
        });
        modalInstance.result.then(() => {
        });
    }

    public editWorkWeek = (workWeekIndex: number) => {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.work_week = {...that.workWeekList[workWeekIndex]};
                    $scope.work_week_index = workWeekIndex;
                    $scope.work_week_option = that.getWorkWeekOption($scope.work_week);
                    $scope.work_week_end_half_day = that.getWorkWeekEndHalfDay($scope.work_week, $scope.work_week_option);
                    $scope.dataChangeEndHalfDay = (args) => {
                        $scope.work_week.endHalfDay = args.new;
                    }
                    $scope.dataChange = (args) => {
                        $scope.work_week_end_half_day = that.getWorkWeekEndHalfDay($scope.work_week, args.new);
                        // Check if we need to update stand and end drop-downs
                        if  (args.new != that.workDayRanges[4]) {
                                    $scope.work_week.endHalfDay = $scope.work_week_end_half_day;
                                    if (args.new == that.workDayRanges[0]) {
                                        $scope.work_week.startDay = that.weekDays[6];
                                        $scope.work_week.endDay = that.weekDays[3];
                                    } else if (args.new == that.workDayRanges[1]) {
                                        $scope.work_week.startDay = that.weekDays[6];
                                        $scope.work_week.endDay = that.weekDays[3];
                                    } else if (args.new == that.workDayRanges[2]) {
                                        $scope.work_week.startDay = that.weekDays[0];
                                        $scope.work_week.endDay = that.weekDays[4];
                                    } else if (args.new == that.workDayRanges[3]) {
                                        $scope.work_week.startDay = that.weekDays[0];
                                        $scope.work_week.endDay = that.weekDays[4];
                                    }
                        }
                    }
                    $scope.ok = () => {
                        that.bsLoadingOverlayService.start({referenceId: 'loader'});
                        if (workWeekIndex == 0) {
                            that.org.extra.leave.work_week_start = $scope.work_week.startDay;
                            that.org.extra.leave.work_week_end = $scope.work_week.endDay;
                            that.org.extra.leave.work_week_end_half_day = $scope.work_week.endHalfDay;
                            that.save_page();
                        } else {
                            let workWeekOffset = $scope.work_week.id - 1;
                            that.org.extra.leave.work_weeks[workWeekOffset] = {
                                description: $scope.work_week.name,
                                work_week_start: $scope.work_week.startDay,
                                work_week_end: $scope.work_week.endDay,
                                work_week_end_half_day: $scope.work_week.endHalfDay
                            }
                            that.save_page();
                        }
                        $uibModalInstance.dismiss();
                    };

                    $scope.cancel = () => {
                        that.toaster.pop('warning', 'Cancelled', 'No changes were made. Cancelled by user.');
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            templateUrl: '/static/templates/organization/workweek_edit_modal.html'
        });
        modalInstance.result.then(() => {
        });

    }

    public addWorkWeek = () => {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.work_week = {
                        id: null,
                        name: '',
                        startDay: that.org.extra.leave.work_week_start,
                        endDay: that.org.extra.leave.work_week_end,
                        endHalfDay: that.org.extra.leave.work_week_end_half_day
                    };
                    $scope.work_week_index = -1;
                    $scope.work_week_option = that.getWorkWeekOption($scope.work_week);
                    $scope.work_week_end_half_day = that.getWorkWeekEndHalfDay($scope.work_week, $scope.work_week_option);
                    $scope.dataChangeEndHalfDay = (args) => {
                        $scope.work_week.endHalfDay = args.new;
                    }
                    $scope.dataChange = (args) => {
                        $scope.work_week_end_half_day = that.getWorkWeekEndHalfDay($scope.work_week, args.new);
                        // Check if we need to update stand and end drop-downs
                        if  (args.new != that.workDayRanges[4]) {
                                    $scope.work_week.endHalfDay = $scope.work_week_end_half_day;
                                    if (args.new == that.workDayRanges[0]) {
                                        $scope.work_week.startDay = that.weekDays[6];
                                        $scope.work_week.endDay = that.weekDays[3];
                                    } else if (args.new == that.workDayRanges[1]) {
                                        $scope.work_week.startDay = that.weekDays[6];
                                        $scope.work_week.endDay = that.weekDays[3];
                                    } else if (args.new == that.workDayRanges[2]) {
                                        $scope.work_week.startDay = that.weekDays[0];
                                        $scope.work_week.endDay = that.weekDays[4];
                                    } else if (args.new == that.workDayRanges[3]) {
                                        $scope.work_week.startDay = that.weekDays[0];
                                        $scope.work_week.endDay = that.weekDays[4];
                                    }
                        }
                    }
                    $scope.ok = () => {
                        that.bsLoadingOverlayService.start({referenceId: 'loader'});
                        if (!that.org.extra.leave.work_weeks) {
                            that.org.extra.leave.work_weeks = [];
                        }
                        that.org.extra.leave.work_weeks.push(
                            {
                                description: $scope.work_week.name,
                                work_week_start: $scope.work_week.startDay,
                                work_week_end: $scope.work_week.endDay,
                                work_week_end_half_day: $scope.work_week.endHalfDay
                            }
                        );
                        that.save_page();
                        $uibModalInstance.dismiss();
                    };

                    $scope.cancel = () => {
                        that.toaster.pop('warning', 'Cancelled', 'No changes were made. Cancelled by user.');
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            templateUrl: '/static/templates/organization/workweek_edit_modal.html'
        });
        modalInstance.result.then(() => {
        });

    }

    public orgLogo(newValue: any): void {
        this.currentDetails.image = newValue;
        if (this.org.id === this.User.getUserId()) {
            this.$scope.$root.$broadcast(
                'profilePicChanged',
                {'imageUrl': newValue}
            );
        }
    }

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }

            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public nextCallout(params: any): any {
        this.isCurrent = this.isCurrent + 1;
        this.changeTab = this.isCurrent - 1;
    }

    public nextTour(): any {
        this.$state.go('root.benefits.manage-insurance');
    }

    /**
     * dynamically assign models depending on selection of office/department/division
     * then check if any of the values are empty strings or undefined
     * reassign them to the default value if they are so ILE is possible.
     */

    public newNavigateOffice():any {
        this.currentOfficeArray = [];
        for (const office of this.org.extra.offices) {
            const currentOffice = {
                name: ((office.name === '' || office.name === undefined)
                        ? this.defaultValue
                        : office.name
                ),

                description: ((office.description === '' || office.description === undefined)
                        ? this.defaultValue
                        : office.description
                ),

                address: ((office.address === '' || office.address === undefined)
                        ? this.defaultValue
                        : office.address
                ),

                country: ((office.country === '' || office.country === undefined)
                        ? this.defaultValue
                        : office.country
                ),
                convertedSuperior: this.getConvertedSuperior(office.manager),
                manager: this.getConvertedSuperior(office.manager),
                divisions: this.addDivisionsToOffice(office.divisions),
                business_licences: this.addBusinessLicenseToOffice(office.business_licences),
                documents: this.addDocumentsToOffice(office.documents)
            };

            this.currentOfficeArray.push(currentOffice);
        }
    }

    private addDivisionsToOffice(divisionObject:any):any {
        const currentDivision = [];
        if (divisionObject !== undefined) {
            for (const dev of divisionObject) {
                this.currentDivision = {
                    name: ((dev.name === '' || dev.name === undefined)
                            ? this.defaultValue
                            : dev.name
                    ),
    
                    description: ((dev.description === '' || dev.description === undefined)
                            ? this.defaultValue
                            : dev.description
                    ),
                    convertedSuperior: this.getConvertedSuperior(dev.manager),
                    manager: this.getConvertedSuperior(dev.manager),
                    departments: this.addDepartmentsToOffice(dev.departments)
                };
                currentDivision.push(this.currentDivision);
            }
        }
        return currentDivision;
    }

    private addDepartmentsToOffice(departmentObject:any):any {
        const currentDepartment = [];
        if (departmentObject !== undefined) {
            for (const dev of departmentObject) {
                this.currentDepartment = {
                    name: ((dev.name === '' || dev.name === undefined)
                            ? this.defaultValue
                            : dev.name
                    ),

                    description: ((dev.description === '' || dev.description === undefined)
                            ? this.defaultValue
                            : dev.description
                    ),
                    convertedSuperior: this.getConvertedSuperior(dev.manager),
                    manager: this.getConvertedSuperior(dev.manager),
                };
                currentDepartment.push(this.currentDepartment);
            }
        }
        return currentDepartment;
    }

    private addBusinessLicenseToOffice(business_licences) {
        const businessLicences = [];
        if (business_licences !== undefined) {
            for (const bl of business_licences) {
                this.currentLicence = {
                    name: ((bl.name === '' || bl.name === undefined)
                            ? this.defaultValue
                            : bl.name
                    ),
                    registration_type: ((bl.registration_type === '' || bl.registration_type === undefined)
                            ? this.defaultValue
                            : bl.registration_type
                    ),
                    description: ((bl.description === '' || bl.description === undefined)
                            ? this.defaultValue
                            : bl.description
                    ),
                    expiry_date: ((bl.expiry_date === '' || bl.expiry_date === undefined)
                            ? this.defaultValue
                            : bl.expiry_date
                    ),

                    file: ((bl.file === '' || bl.file === undefined)
                        ? this.defaultValue
                        : bl.file
                    ),
                    fileName: ((bl.file === '' || bl.file === undefined)
                        ? this.defaultValue
                        : this.fileName(bl.file)
                    ),
                }
                if ((this.currentDocument.file || this.currentDocument.file !== this.defaultValue) && !this.new_logo) {
                    this.fileDirModel.fileName = this.parseFileName(this.currentDocument.file);
                }
                businessLicences.push(this.currentLicence);
            }
        }
        return businessLicences;
    }

    private addDocumentsToOffice(documentsObject:any):any {
        const currentDocuments = [];
        if (documentsObject !== undefined) {
            for (const doc of documentsObject) {
                this.currentDocument = {
                    title: ((doc.title === '' || doc.title === undefined)
                            ? this.defaultValue
                            : doc.title
                    ),
    
                    description: ((doc.description === '' || doc.description === undefined)
                            ? this.defaultValue
                            : doc.description
                    ),
                    expiryDate: ((doc.expiry_date === '' || doc.expiry_date === undefined)
                            ? this.defaultValue
                            : doc.expiry_date
                    ),
    
                    file: ((doc.file === '' || doc.file === undefined)
                            ? this.defaultValue
                            : doc.file
                    ),
                    fileName: ((doc.file === '' || doc.file === undefined)
                            ? this.defaultValue
                            : this.fileName(doc.file)
                    ),
                };
                if ((this.currentDocument.file || this.currentDocument.file !== this.defaultValue) && !this.new_logo) {
                    this.fileDirModel.fileName = this.parseFileName(this.currentDocument.file);
                }
                currentDocuments.push(this.currentDocument);
            }
        }
        return currentDocuments;
    }

    private getConvertedSuperior(id:string):any {
        if (!id) {
            this.convertedSuperior = '';
        } else {
            this.convertedSuperior = {
                id: id,
                name: this.get_name(id)
            };
        }
        return this.convertedSuperior;
    }

    public new_Delete_Modal = (what: string, obj:any, index: number, parentIndex: number):any => {
        let that: this = this;
        this.new_logo = false;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance',
                function ($scope: any, $uibModalInstance: any): void {
                    $scope.C = that;
                    $scope.what = what;
                    $scope.obj = obj;
                }],

            templateUrl: '/static/templates/organization/delete_modal.html'
        });

        modalInstance.result.then(() => {
            this.org.extra.offices[parentIndex][what] = this.org.extra.offices[parentIndex][what].filter(item => item !== obj)
            this.save_page()
        });
    }
    public navigateBenefits(oKey: any, oObj: any, index: any): any {
        if (oObj === 'benefit') {
            this.benefitIndex = index;
            this.currentBenefit = {
                name: ((oKey.name === '' || oKey.name === undefined)
                        ? this.defaultValue
                        : oKey.name
                ),

                description: ((oKey.description === '' || oKey.description === undefined)
                        ? this.defaultValue
                        : oKey.description
                ),
            };
        } else if (oObj === 'benefit-doc') {
            this.benefitdocIndex = index;
            this.currentBenfitDoc = {
                title: ((oKey.title === '' || oKey.title === undefined)
                        ? this.defaultValue
                        : oKey.title
                ),

                description: ((oKey.description === '' || oKey.description === undefined)
                        ? this.defaultValue
                        : oKey.description
                ),

                file: ((oKey.file === '' || oKey.file === undefined)
                        ? this.defaultValue
                        : oKey.file
                ),
            };
            
            if ((this.currentBenfitDoc.file !== '' || this.currentBenfitDoc.file !== undefined || this.currentBenfitDoc.file !== this.defaultValue) && !this.new_logo) {
                this.fileDirModel.fileName = this.parseFileName(oKey.file);
            }
        }
    }

    public fileName(filename: string) {
        return this.parseFileName(filename);
    }

    // start of save methods
    private save_page(): any {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});

        // fix broken default values
        if (this.org.extra.legal) {
            if (this.org.extra.legal.type === 'Select an option') {
                delete this.org.extra.legal.type;
            }
        }

        let annualCycleStartDate: any = this.org.extra.leave.annual_cycle_start_date;
        if (this.org.extra.leave && annualCycleStartDate && annualCycleStartDate === '---') {
            delete this.org.extra.leave.annual_cycle_start_date;
        }

        // save marketing info
        if (this.form_models.marketing) {

            // unchecked values are undefined in the model
            if (this.form_models.marketing.lead_capture) {
                this.org.extra.marketing.lead_capture = true;
            } else {
                this.org.extra.marketing.lead_capture = false;
            }
        }

        let url: string = '/api/' + (this.$stateParams['id']
                ? ('orgs/' + this.$stateParams.id)
                : 'org'
        );
        this.$http.put(url, this.Api.stripRestangular(this.org))
            .then((org: any) => {
                    // Check if we need to emit an event log
                    if (this.empEventName) {
                        this.emitEvent(this.empEventName, this.empEventAddData);

                        // Reset event data
                        this.empEventName = '';
                        this.empEventAddData = '';
                    }

                    this.org = org.data;
                    this.checkLoading();
                    this.newNavigateOffice();
                    this.toaster.pop('success', 'Saved');
                    this.editing = false;
                    this.editing_new = false;
                    this.form_models.leave = org.data.extra.leave;
                    this.form_models.marketing = org.data.extra.marketing;
                },
                (response: any) => {
                    this.checkLoading();
                    if (response.status === 403) {
                        this.toaster.pop('error', 'Access Denied', response.data.detail);
                    } else if (response.status === 400) {
                        this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
                    } else {
                        this.toaster.pop('error', 'Server error', 'Please, try again later');
                    }
                });
    }


    public add_request_document(isNewDoc: any, docModel?: any, editDocType?: any): any {
        this.fileDirModel = {
            fileName: 'Select a file',
            fileLink: undefined
        };
        this.new_logo = false;
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.docModel = undefined;
                    $scope.confirmation = false;
                    $scope.addingDocument = isNewDoc;
                    $scope.docType = that.defaultValue;
                    $scope.modalHeader = (isNewDoc ? 'Add a New Document' : 'Delete Document');
                    $scope.docOptions = ['NOC', 'Table of Benefits', 'Salary Certificate', 'Other', 'Reference Letter'];
                    $scope.key = ['template', 'template1', 'template2', 'template3', 'template4'];
                    $scope.confirmButton = 'Save';
                    $scope.cancelButton = 'Cancel';
                    $scope.saveObj = {};
                    $scope.templateTitle = '';

                    if (docModel !== undefined) {
                        $scope.docModel = docModel;
                        that.fileDirModel.fileName = that.parseFileName($scope.docModel);
                        $scope.docType = editDocType;
                    }

                    $scope.clearObj = function (): void {
                        that.fileDirModel = {
                            fileName: 'Select a file',
                            fileLink: undefined
                        };

                        that.inlineApiData = {
                            id: '',
                            fieldName: '',
                            currentValue: '',
                            newValue: '',
                            dataVersionId: ''
                        };
                    };

                    if ($scope.addingDocument) {
                        $scope.docModel = undefined;
                        $scope.typeSet = false;
                    }

                    $scope.setDocType = function (params: any): void {
                        $scope.typeSet = true;
                        let selected: any = params.new;
                        switch (selected) {
                            case 'Table of Benefits': {
                                $scope.docType = 'table_of_benefits';
                                $scope.maxTemps = 1;
                                break;
                            }
                            case 'NOC': {
                                $scope.docType = 'NOC';
                                $scope.maxTemps = 5;
                                break;
                            }
                            case 'Salary Certificate': {
                                $scope.docType = 'salary certificate';
                                $scope.maxTemps = 5;
                                break;
                            }
                            case 'Other': {
                                $scope.docType = 'other';
                                $scope.maxTemps = 5;
                                break;
                            }
                            case 'Reference Letter': {
                                $scope.docType = 'reference letter';
                                $scope.maxTemps = 5;
                                break;
                            }
                            default: {
                                break;
                            }
                        }

                        if (selected === 'Table of Benefits') {
                            if (that.org.extra.processes.document === {} || that.org.extra.processes.document['table_of_benefits']) {
                                $scope.canAddNew = false;
                            } else {
                                $scope.canAddNew = true;
                            }

                        } else {
                            let obj: any = that.org.extra.processes.document[$scope.docType];
                            // number of current items in the array for that doc type
                            let x: any;
                            if (!that.org.extra.processes.document[$scope.docType]) {
                                x = 0;
                            } else {
                                x = Object.keys(that.org.extra.processes.document[$scope.docType]).length;
                            }

                            if (x >= $scope.maxTemps) {
                                $scope.canAddNew = false;
                            } else if (x < $scope.maxTemps) {
                                $scope.canAddNew = true;
                                switch (x) {
                                    case 0: {
                                        $scope.templateTitle = 'template';
                                        break;
                                    }
                                    default: {

                                        /**
                                         *  loop through the possible templates and check if any previous to the current are deleted
                                         * if they are then save the current template to the empty template space
                                         */
                                        for (let i: number = 0; i <= x; i++) {
                                            if (!obj[$scope.key[i]]) {
                                                $scope.templateTitle = $scope.key[i];

                                            }
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    };

                    $scope.confirm = () => {
                        if (!$scope.typeSet) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'Please choose a template type'
                            );

                        } else if (!$scope.canAddNew) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'You have reached the maximum amount of templates for this template type.'
                            );

                        } else if (that.inlineApiData.newValue === '') {
                            that.toaster.pop('warning', 'Warning', 'Please upload a file');

                        } else {
                            $scope.confirmation = true;
                            $scope.saveObj = {
                                confirmation: $scope.confirmation,
                                deleting: false,
                                docType: $scope.docType,
                                templateTitle: $scope.templateTitle,
                                saveData: that.inlineApiData
                            };

                            $uibModalInstance.close($scope.saveObj);
                        }
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.delete = () => {
                        $scope.confirmation = true;
                        $scope.saveObj = {
                            confirmation: $scope.confirmation,
                            deleting: true,
                            docType: $scope.docType,
                            templateTitle: $scope.templateTitle,
                            saveData: {
                                org: that.org.id,
                                file: $scope.docModel
                            }
                        };

                        $uibModalInstance.close($scope.saveObj);
                    };
                }],

            templateUrl: '/static/templates/modals/add_request_doc.html'
        });

        modalInstance.result.then(
            (result) => {
                if (result.confirmation) {
                    this.bsLoadingOverlayService.start({
                        referenceId: 'loader'
                    });

                    if (result.deleting === true) {
                        let link: any;
                        let obj: any;

                        // tob deleting
                        if (result.docType === 'table_of_benefits') {
                            delete this.org.extra.processes.document.table_of_benefits;
                            this.empEventName = 'org.process.doc.table_of_benefits.file_delete';
                        } else {

                            // other field deleting
                            link = result.saveData.file;
                            obj = this.org.extra.processes.document[result.docType];
                            this.empEventName = 'org.process.doc.' + result.docType + '.file_delete';

                            // find the value of the link and remove it from the object
                            Object.keys(obj).forEach(
                                function (key: string): void {
                                    if (obj[key] === link) {
                                        delete obj[key];
                                    }
                                }
                            );

                            if (this.org.extra.processes.document[result.docType] === {}) {
                                delete this.org.extra.processes.document[result.docType];
                            }

                            let objLen: number = Object.keys(that.org.extra.processes.document[result.docType]).length;
                            if (objLen === 0) {
                                delete this.org.extra.processes.document[result.docType];
                            }
                        }

                        this.save_page();
                    } else if (result.deleting === false) {
                        if (!that.org.extra.processes.document[result.docType]) {
                            that.org.extra.processes.document[result.docType] = {};
                        }

                        /** index into the correct object here and add the template to the org obj
                         * push obj back to server and save
                         * table of benefits saves as a string variable and not as an obj that you index into
                         */
                        if (result.docType === 'table_of_benefits') {
                            this.org.extra.processes.document['table_of_benefits'] = result.saveData.newValue;
                        } else {

                            this.org.extra.processes.document[result.docType][result.templateTitle] = result.saveData.newValue;
                        }
                        this.empEventName = 'org.process.doc.' + result.docType + '.file_upload';
                        this.save_page();
                    }
                } else {
                    this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
                }

                this.bsLoadingOverlayService.stop({
                    referenceId: 'loader'
                });
            }
        );
    }

    public inlineEditingSaveFixedSalary = function (params: any): void {
        if (params.new == this.fixedSalaryRanges[1]) {
            this.variableSalaryValue = this.variableSalaryRanges[0];

            this.org.extra.processes.payroll_export.fixed_salary_allowances = true;
            this.org.extra.processes.payroll_export.variable_salary_allowances = false;
        } else {
            this.org.extra.processes.payroll_export.fixed_salary_allowances = false;
        }

        this.save_page();
    }

    public inlineEditingSaveVariableSalary = function (params: any): void {
        if (params.new == this.variableSalaryRanges[1]) {

            this.org.extra.processes.payroll_export.variable_salary_allowances = true;
        } else {
            this.org.extra.processes.payroll_export.variable_salary_allowances = false;
        }

        this.save_page();
    }

    public inlineEditingSaveWorkRange = function (params: any): void {

        // Skip processing if using custom ranges
        if (params.new == this.workDayRanges[4]) {
            return ;
        }

        if (params.new == this.workDayRanges[0]) {
            this.org.extra.leave.work_week_start = this.weekDays[6];
            this.org.extra.leave.work_week_end = this.weekDays[3];
            this.org.extra.leave.work_week_end_half_day = false;
        } else if (params.new == this.workDayRanges[1]) {
            this.org.extra.leave.work_week_start = this.weekDays[6];
            this.org.extra.leave.work_week_end = this.weekDays[3];
            this.org.extra.leave.work_week_end_half_day = true;
        } else if (params.new == this.workDayRanges[2]) {
            this.org.extra.leave.work_week_start = this.weekDays[0];
            this.org.extra.leave.work_week_end = this.weekDays[4];
            this.org.extra.leave.work_week_end_half_day = false;
        } else if (params.new == this.workDayRanges[3]) {
            this.org.extra.leave.work_week_start = this.weekDays[0];
            this.org.extra.leave.work_week_end = this.weekDays[4];
            this.org.extra.leave.work_week_end_half_day = true;
        }
        this.save_page();
    }

    public inlineEditingSave = function (params: any): void {
        // this is the main inline editing save function.
        this.inlineApiData = {
            id: this.org.id,
            fieldName: params.model,
            currentValue: params.old,
            newValue: params.new,
            dataVersionId: 'still to fillout'
        };

        let model: any = params.model;
        let pageObj: any = model.split('.')[1];
        if (model.startsWith('C.' + pageObj + '.')) {
            model = model.substr(('C.' + pageObj + '.').length);
        }
        // TODO: check if we should update
        if (this.inlineApiData.currentValue !== this.inlineApiData.newValue) {
            switch (pageObj) {
                case 'currentDetails': {
                    this.saveOrganisation(model, pageObj);
                    break;
                }
                case 'currentLeaveObject': {
                    this.saveProcesses(model, pageObj);
                    break;
                }
                case 'currentDepartment': {
                    this.saveDepartment(model, pageObj);
                    break;
                }
                case 'currentBenefit': {
                    this.saveBenefit(model, pageObj);
                    break;
                }
                case 'currentBenfitDoc': {
                    this.saveBenefitdoc(model, pageObj);
                    break;
                }
                default: {
                    break;
                }
            }
        }

    };

    public addToInsuranceContacts = () => {
        // if (args !== null && args.new !== '') {
        //     this.currentDetails.insuranceContacts.push(args.new);
        //     this.insuranceContactEmail = '';
        //     this.org.extra.insurance.insurance_contracts = this.currentDetails.insuranceContacts;
        //     this.save_page();
        // }
        const contact = {
            name: '',
            email: '',
        };
        const that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 
                function ($scope: any, $uibModalInstance: any, toaster: any, $http: any, bsLoadingOverlayService: any): any {
                    $scope.C = that;
                    $scope.model = that.contact;
                    $scope.addEmployeeContact = () => {
                        $uibModalInstance.close($scope.model);
                    };
            }],

            templateUrl: '/static/templates/modals/add_insurance_contact_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result !== undefined) {
                this.currentDetails.insuranceContacts.push(result);
                this.org.extra.insurance.insurance_contacts = this.currentDetails.insuranceContacts;
                this.save_page();
            }
        });
    };

    public removeFromInsuranceContacts = (args: any) => {
        if (args !== null) {
            const index = this.currentDetails.insuranceContacts.indexOf((cont) => cont.email === args.email);
            this.currentDetails.insuranceContacts.splice(index, 1);
            this.org.extra.insurance.insurance_contacts = this.currentDetails.insuranceContacts;
            this.save_page();
        }
    };

    public inlineEditingOfficeSave = function (params: any, officeIndex: number, divisionIndex: number, departmentIndex, pageObj: any): void {
        // this is the main inline editing save function.
        this.inlineApiData = {
            id: this.org.id,
            fieldName: params.model,
            currentValue: params.old,
            newValue: params.new,
            dataVersionId: 'still to fillout'
        };

        let model: any = params.model;
        let currentModel: string;
        currentModel = model.split('.').pop();
        model = currentModel;

        if (this.inlineApiData.currentValue !== this.inlineApiData.newValue) {
            switch (pageObj) {
                case 'office': {
                    this.saveOffice(model, pageObj, officeIndex);
                    break;
                }
                case 'division': {
                    this.saveDivision(model, pageObj, officeIndex, divisionIndex);
                    break;
                }
                case 'business_licence': {
                    this.saveLicence(model, pageObj, officeIndex, divisionIndex);
                    break;
                }
                case 'document': {
                    this.saveDocument(model, pageObj, officeIndex, divisionIndex);
                    break;
                }
                case 'department': {
                    this.saveDepartment(model, pageObj, officeIndex, divisionIndex, departmentIndex);
                    break;
                }
                default: {
                    break;
                }
            }
        }

    };

    public saveOrganisation(model: any, pageObj: any): void {
        // console.log('saveOrganisation', model, pageObj);
        // console.log('this.inlineApiData', this.inlineApiData.newValue);
        switch (model) {
            case 'organisationName': {
                this.org.name = this.inlineApiData.newValue;
                break;
            }
            case 'image': {
                break;
            }
            case 'webSiteUrl': {
                this.org.extra.details.url = this.inlineApiData.newValue;
                break;
            }
            case 'industry': {
                this.org.extra.details.industry = this.inlineApiData.newValue;
                break;
            }
            case 'numberOfEmployees': {
                this.org.extra.details.number_of_employees = this.inlineApiData.newValue;
                break;
            }
            case 'contactAddress': {
                this.org.extra.details.contact_address = this.inlineApiData.newValue;
                break;
            }
            case 'contactEmail': {
                this.org.extra.details.contact_email = this.inlineApiData.newValue;
                break;
            }
            case 'contactPhoneNumber': {
                this.org.extra.details.contact_phone = this.inlineApiData.newValue;
                break;
            }
            case 'currency': {
                this.org.extra.details.currency = this.inlineApiData.newValue;
                break;
            }
            case 'workHoursStart': {

                // TODO: TO REVIEW
                this.convertedTimeStart = this.inlineApiData.newValue;
                let stringTime: string = this.inlineApiData.newValue.toString();
                this.org.extra.details.work_hours_start = stringTime + ':00';
                break;
            }
            case 'workHoursEnd': {
                let stringTime: string = this.inlineApiData.newValue.toString();
                this.org.extra.details.work_hours_end = stringTime + ':00';
                break;
            }
            case 'leaveAnnualStartDate': {
                this.org.extra.leave.annual_cycle_start_date = this.inlineApiData.newValue;
                break;
            }
            case 'contactforAdditionServices': {
                this.org.extra.marketing.lead_capture = this.inlineApiData.newValue;
                break;
            }
            case 'trackDependantsOnCompanyProgram': {
                this.org.extra.details.track_dependants_visa_on_company_program = this.inlineApiData.newValue;
                break;
            }
            case 'trackDependantsOffCompanyProgram': {
                this.org.extra.details.track_dependants_visa_off_company_program = this.inlineApiData.newValue;
                break;
            }
            case 'canEditPersonal': {
                this.org.extra.details.employee_can_edit_personal = this.inlineApiData.newValue;
                break;
            }
            case 'canEnrollInTrial': {
                this.org.extra.trial.can_select = this.inlineApiData.newValue;
                // Disabled all trial features
                if (!this.org.extra.trial.can_select) {
                    // Disable feature when trial ends
                    this.org.extra.trial.enrolled = false;
                    this.org.extra.trial.endOn= moment().format('YYYY-MM-DD');
                    this.org.extra.details.employee_can_edit_personal = false;
                    this.trialEnabled = false;
                    this.trialEmployeeOwnEdit = false;
                }
                break;
            }
            case 'hubspotSignUp': {
                this.org.extra.details.hubspot_signup = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveProcesses(model: any, pageObj: any): void {
        switch (model) {
            case 'paidLeave': {
                this.org.extra.leave.paid_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'sickLeave': {
                this.org.extra.leave.sick_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'maternityLeave': {
                this.org.extra.leave.maternity_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'paternityLeave': {
                this.org.extra.leave.paternity_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'carriedForward': {
                this.org.extra.leave.carried_forward = +this.inlineApiData.newValue;
                break;
            }
            case 'carriedForwardNextYear': {
                this.org.extra.leave.show_next_year_carried_forward = this.inlineApiData.newValue;
                break;
            }
            case 'workWeekStart': {
                this.org.extra.leave.work_week_start = this.inlineApiData.newValue;
                break;
            }
            case 'workWeekEnd': {
                this.org.extra.leave.work_week_end = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveOffice(model: any, pageObj: any, index: any): void {
        switch (model) {
            case 'name': {
                this.org.extra.offices[index].name = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.offices[index].description = this.inlineApiData.newValue;
                break;
            }
            case 'address': {
                this.org.extra.offices[index].address = this.inlineApiData.newValue;
                break;
            }
            case 'country': {
                this.org.extra.offices[index].country = this.inlineApiData.newValue;
                break;
            }
            case 'manager': {
                this.org.extra.offices[index].manager = this.inlineApiData.newValue['id'];
                break;
            }
            default: {
                break;
            }
        }
        this.save_page();
    }

    public saveDivision(model: any, pageObj: any, officeIndex: number, divisionIndex: number): void {
        switch (model) {
            case 'name': {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].name = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].description = this.inlineApiData.newValue;
                break;
            }
            case 'manager': {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].manager = this.inlineApiData.newValue['id'];
                break;
            }
            default: {
                break;
            }
        }
        this.save_page();
    }

    public saveLicence(model: any, pageObj: any, officeIndex: number, index: number): void {
        switch (model) {
            case 'name': {
                this.org.extra.offices[officeIndex].business_licences[index].name = this.inlineApiData.newValue;
                break;
            }
            case 'registration_type': {
                this.org.extra.offices[officeIndex].business_licences[index].registration_type = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.offices[officeIndex].business_licences[index].description = this.inlineApiData.newValue;
                break;
            }
            case 'expiry_date':
            case 'expiryDate': {
                this.org.extra.offices[officeIndex].business_licences[index].expiry_date = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }
        this.save_page();
    }

    public saveDocument(model: any, pageObj: any, officeIndex: number, index: number): void {
        switch (model) {
            case 'title': {
                this.org.extra.offices[officeIndex].documents[index].title = this.inlineApiData.newValue;
                break;
            }
            case 'file': {
                this.org.extra.offices[officeIndex].documents[index].file = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.offices[officeIndex].documents[index].description = this.inlineApiData.newValue;
                break;
            }
            case 'expiry_date':
            case 'expiryDate':
            {
                this.org.extra.offices[officeIndex].documents[index].expiry_date = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }
        this.save_page();
    }

    public saveDepartment(model: any, pageObj: any, officeIndex: number, divisionIndex: number, departmentIndex: number): void {
        switch (model) {
            case 'name': {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].departments[departmentIndex].name = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].departments[departmentIndex].description = this.inlineApiData.newValue;
                break;
            }
            case 'manager': {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].departments[departmentIndex].manager = this.inlineApiData.newValue['id'];
                break;
            }
            default: {
                break;
            }
        }

        this.save_page();
    }

    public saveBenefit(model: any, pageObj: any, index: any): void {
        switch (model) {
            case 'name': {
                this.org.extra.benefits[this.benefitIndex].name = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.benefits[this.benefitIndex].description = this.inlineApiData.newValue;
                break;
            }
            case 'document': {
                this.org.extra.benefits[this.benefitIndex].document = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveBenefitdoc(model: any, pageObj: any, index: any): void {
        switch (model) {
            case 'title': {
                this.org.extra.benefits[this.benefitIndex].documents[this.benefitdocIndex].title = this.inlineApiData.newValue;
                break;
            }
            case 'description': {
                this.org.extra.benefits[this.benefitIndex].documents[this.benefitdocIndex].description = this.inlineApiData.newValue;
                break;
            }
            case 'file': {
                this.org.extra.benefits[this.benefitIndex].documents[this.benefitdocIndex].file = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public uploadILEFiles = function (params: any, officeIndex: number = null, businessLicenceIndex: number = null): void {
        let that: any = this;
        this.bsLoadingOverlayService.start({
            referenceId: 'loader'
        });

        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                that.docObj.file = response.data.url;
                that.fileDirModel.fileName = that.parseFileName(that.docObj.file);
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.inlineApiData = {
                    orgId: this.org.id,
                    fieldName: params.fileType,
                    currentValue: params.old, /// this needs to be cleared out and linked to the current object.
                    newValue: response.data.url,
                    employeeDataVersionId: 'still to fillout'
                };

                switch (params.fileType) {
                    case 'orgLogo':
                        this.orgLogo(this.inlineApiData.newValue);
                        this.org.extra.image = response.data.url;
                        this.new_logo = true;
                        break;

                    case 'office_doc':
                        this.new_office_doc.file = response.data.url;
                        this.new_logo = false;
                        break;

                    case 'business_lic':
                        this.new_bl_doc = response.data.url;
                        this.org.extra.offices[officeIndex].business_licences[businessLicenceIndex]['file'] = response.data.url;
                        this.new_logo = false;
                        break;
                    case 'benefit_doc':
                        this.new_benefit_doc.file = response.data.url;
                        this.new_logo = false;
                        break

                }
                this.save_page();

                // if (params.fileType === 'orgLogo') {
                // }
                //
                // if (params.fileType === 'office_doc') {
                //     this.new_office_doc.file = response.data.url;
                // }
                //
                // if (params.fileType === 'business_lic') {
                //     this.new_bl_doc = response.data.url;
                // }
                //
                // if (params.fileType === 'benefit_doc') {
                //     this.new_benefit_doc.file = response.data.url;
                // }

            },
            (response) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public deleteLogoUpload = function (): void {
        this.new_logo = true;
        this.org.extra.image = '';
        this.fileDirModel.fileLink = undefined;
        this.fileDirModel.fileName = 'Select a file';
        this.currentDetails.image = '';
        this.save_page();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    };

    public deleteBenefitDocUpload = function (): void {
        this.new_logo = false;
        this.org.extra.benefits[this.benefitIndex].documents[this.benefitdocIndex].file = '';
        this.fileDirModel.fileLink = undefined;
        this.fileDirModel.fileName = 'Select a file';
        this.save_page();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    };

    // called when you add an office to the current org
    public add_office(): any {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.model = that.new_office;
                    $scope.countries = that.officeCountry;
                    $scope.options = that.employeeSelectList;
                    $scope.add = () => {
                        if (that.org.extra.offices.filter(e => e.name === $scope.model.name).length > 0) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'An office with that name already exists.'
                            );
                            return;
                        }
                        $uibModalInstance.close($scope.model);
                    };
                }],

            templateUrl: '/static/templates/modals/add_office.html'
        });

        modalInstance.result.then((i) => {
            that.bsLoadingOverlayService.start({
                referenceId: 'requests_loader'
            });

            let add_item: any = {};
            add_item['name'] = i.name;
            add_item['address'] = i.address;
            if (i.description) {
                add_item['description'] = i.description;
            }

            if (i.country) {
                add_item['country'] = i.country;
            }

            if (i.manager) {
                add_item['manager'] = i.manager.id;
            }

            that.org.extra.offices.push(add_item);
            that.emitEvent('org.offices.add');
            that.save_page();
            that.bsLoadingOverlayService.stop({
                referenceId: 'requests_loader'
            });
        });
        
    }

    public add_division(index): any {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.model = that.new_division;
                    $scope.options = that.employeeSelectList;
                    $scope.add = () => {
                        if (that.org.extra.offices[index].divisions &&
                            that.org.extra.offices[index].divisions.filter(e => e.name === $scope.model.name).length > 0) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'A division with that name already exists.'
                            );
                            return;
                        }
                        $uibModalInstance.close($scope.model);
                    };
                }],

            templateUrl: '/static/templates/modals/add_division.html'
        });

        modalInstance.result.then((i) => {
            // that.bsLoadingOverlayService.start({
            //     referenceId: 'requests_loader'
            // });

            let add_item: any = {};
            add_item['name'] = i.name;
            if (i.description) {
                add_item['description'] = i.description;
            }

            if (i.manager) {
                add_item['manager'] = i.manager.id;
            }

            if (!that.org.extra.offices[index]['divisions']) {
                that.org.extra.offices[index]['divisions'] = [];
            }

            that.org.extra.offices[index].divisions.push(add_item);
            that.emitEvent('org.offices.division.add');
            that.save_page();
            
            // manually update schema array
            that.office.divisions = that.org.extra.offices[index].divisions;
            
            that.bsLoadingOverlayService.stop({
                referenceId: 'loader'
            });
        });
    }

    public add_department(officeIndex, divisionIndex): any {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.model = that.new_department;
                    $scope.options = that.employeeSelectList;
                    $scope.add = () => {
                        if (that.org.extra.offices[officeIndex].divisions[divisionIndex].departments &&
                            that.org.extra.offices[officeIndex].divisions[divisionIndex].departments
                                .filter(e => e.name === $scope.model.name).length > 0) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'A department with that name already exists.'
                            );
                            return;
                        }
                        $uibModalInstance.close($scope.model);
                    };
                }],
            templateUrl: '/static/templates/modals/add_department.html'
        });

        modalInstance.result.then((i) => {
            that.bsLoadingOverlayService.start({referenceId: 'requests_loader'});
            let add_item: any = {};
            add_item['name'] = i.name;
            if (i.description) {
                add_item['description'] = i.description;
            }

            if (i.manager) {
                add_item['manager'] = i.manager.id;
            }

            if (!that.org.extra.offices[officeIndex].divisions[divisionIndex]['departments']) {
                that.org.extra.offices[officeIndex].divisions[divisionIndex]['departments'] = [];
            }

            that.org.extra.offices[officeIndex].divisions[divisionIndex].departments.push(add_item);
            that.emitEvent('org.offices.department.add');

            that.save_page();
            // manually update schema array
            that.division.departments = that.org.extra.offices[that.officeIndex].divisions[that.divisionIndex].departments;
            that.bsLoadingOverlayService.stop({
                referenceId: 'requests_loader'
            });
        });
    }

    public new_add_bl = (index):any => {
        this.new_bl = {
            name: '',
            type: '',
            expiryDate: '',
            description: '',
        };
        this.fileDirModel = {
            fileName: 'Select a file',
            fileLink: undefined
        };
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.model = that.new_bl;
                    $scope.licence_type = that.licenceType;
                    $scope.add = () => {
                        if ($scope.model.file) {
                            if (that.org.extra.offices[index].business_licences &&
                                that.org.extra.offices[index].business_licences
                                    .filter(e => e.name === $scope.model.name).length > 0) {
                                that.toaster.pop(
                                    'warning',
                                    'Warning',
                                    'An office document with that name already exists.'
                                );
                                return;
                            }
                            $uibModalInstance.close($scope.model);
                        } else {
                            toaster.pop(
                                'warning',
                                'Warning',
                                'Please upload a file to create a new office document.'
                            );
                        }
                    };
                }],
            templateUrl: '/static/templates/modals/add_business_licence.html'
        });
        modalInstance.result.then((i) => {
            
            that.bsLoadingOverlayService.start({referenceId: 'loader'});
            let add_item: any = {};
            add_item['name'] = i.name;
            add_item['file'] = this.new_bl_doc;
            if (i.type) {
                add_item['registration_type'] = i.type;
            }
            if (i.description) {
                add_item['description'] = i.description;
            }
            if (i.expiryDate) {
                add_item['expiry_date'] = moment(i.expiryDate).format('YYYY-MM-DD');
            }
            if (!that.org.extra.offices[index]['business_licences']) {
                that.org.extra.offices[index]['business_licences'] = [];
            }
            that.org.extra.offices[index].business_licences.push(add_item);
            that.emitEvent('org.offices.business_licence.add');
            that.save_page();
           
            // manually update schema array
            that.office.business_licences = that.org.extra.offices[index].business_licences;
            that.bsLoadingOverlayService.stop({
                referenceId: 'loader'
            });
        });
    }
    public add_office_doc(index): any {
        this.new_office_doc = {
            title: '',
            description: '',
            file: '',
            expiryDate: ''
        };
        this.fileDirModel = {
            fileName: 'Select a file',
            fileLink: undefined
        };
        let that: this = this;
        this.new_logo = false;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.model = that.new_office_doc;
                    $scope.add = () => {
                        if ($scope.model.file) {
                            if (that.org.extra.offices[index].documents &&
                                that.org.extra.offices[index].documents
                                    .filter(e => e.title === $scope.model.title).length > 0) {
                                that.toaster.pop(
                                    'warning',
                                    'Warning',
                                    'An office document with that name already exists.'
                                );
                                return;
                            }
                            $uibModalInstance.close($scope.model);
                        } else {
                            toaster.pop(
                                'warning',
                                'Warning',
                                'Please upload a file to create a new office document.'
                            );
                        }
                    };
                }],
            templateUrl: '/static/templates/modals/add_office_document.html'
        });
        modalInstance.result.then((i) => {
            that.bsLoadingOverlayService.start({referenceId: 'loader'});
            let add_item: any = {};
            add_item['title'] = i.title;
            if (i.description) {
                add_item['description'] = i.description;
            }
            if (i.file) {
                add_item['file'] = i.file;
            }
            if (i.expiryDate) {
                add_item['expiry_date'] = moment(i.expiryDate).format('YYYY-MM-DD');
            }
            if (!that.org.extra.offices[index]['documents']) {
                that.org.extra.offices[index]['documents'] = [];
            }
            that.org.extra.offices[index].documents.push(add_item);
            that.empEventName = 'org.offices.doc.file_upload';
            that.save_page();
            // manually update schema array
            that.office.documents = that.org.extra.offices[index].documents;
            that.bsLoadingOverlayService.stop({
                referenceId: 'loader'
            });
        });
    }

    public add_benefit_doc(): any {
        this.new_benefit_doc = {
            title: '',
            description: '',
            file: '',
        };
        this.fileDirModel = {
            fileName: 'Select a file',
            fileLink: undefined
        };
        let that: this = this;
        this.new_logo = false;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.model = that.new_benefit_doc;
                    $scope.add = () => {
                        if ($scope.model.file) {
                            if (that.org.extra.benefits[that.benefitIndex].documents &&
                                that.org.extra.benefits[that.benefitIndex].documents
                                    .filter(e => e.title === $scope.model.title).length > 0) {
                                that.toaster.pop(
                                    'warning',
                                    'Warning',
                                    'A benefit document with that name already exists.'
                                );
                                return;
                            }
                            $uibModalInstance.close($scope.model);
                        } else {
                            toaster.pop(
                                'warning',
                                'Warning',
                                'Please upload a file to create a new benefit document.'
                            );
                        }
                    };
                }],
            templateUrl: '/static/templates/modals/add_benefit_doc.html'
        });
        modalInstance.result.then((i) => {
            that.bsLoadingOverlayService.start({referenceId: 'loader'});
            let add_item: any = {};
            add_item['title'] = i.title;
            if (i.description) {
                add_item['description'] = i.description;
            }
            if (i.file) {
                add_item['file'] = i.file;
            }
            if (!that.org.extra.benefits[that.benefitIndex]['documents']) {
                that.org.extra.benefits[that.benefitIndex]['documents'] = [];
            }

            that.org.extra.benefits[that.benefitIndex].documents.push(add_item);
            that.empEventName = 'org.benefits.doc.file_upload';
            that.save_page();
            // manually update schema array
            that.benefit.documents = that.org.extra.benefits[that.benefitIndex].documents;

            that.bsLoadingOverlayService.stop({
                referenceId: 'loader'
            });
        });
    }

    public add_benefit(): any {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any): void {
                    $scope.model = that.new_benefit;
                    $scope.add = () => {
                        if (that.org.extra.benefits &&
                            that.org.extra.benefits
                                .filter(e => e.name === $scope.model.name).length > 0) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'A benefit document with that name already exists.'
                            );
                            return;
                        }
                        $uibModalInstance.close($scope.model);
                    };
                }],
            templateUrl: '/static/templates/modals/add_benefit.html'
        });

        modalInstance.result.then((i) => {
            that.bsLoadingOverlayService.start({
                referenceId: 'requests_loader'
            });

            let add_item: any = {};
            add_item['name'] = i.name;
            if (i.description) {
                add_item['description'] = i.description;
            }

            if (!that.org.extra['benefits']) {
                that.org.extra['benefits'] = [];
            }

            that.org.extra.benefits.push(add_item);
            that.empEventName = 'org.benefits.add';
            that.save_page();
            that.bsLoadingOverlayService.stop({
                referenceId: 'requests_loader'
            });
        });
    }

    public deleteDocItem(obj: any, key: string): void {
        let structure: any;
        this.new_logo = false;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = 'Delete document';
                $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete document';
                $scope.cancelButton = 'Cancel';
                let value: boolean = false;
                $scope.confirm = () => {
                    value = true;
                    $uibModalInstance.close(value);
                };
                $scope.cancel = () => {
                    value = false;
                    $uibModalInstance.close(value);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                if (key === 'benefit') {
                    structure = this.org.extra.benefits[this.benefitIndex].documents;
                } else {
                    structure = this.org.extra.offices[this.officeIndex].documents;
                }
                structure = structure.filter(docObj => docObj.title !== obj.title);
                if (key === 'benefit') {
                    this.org.extra.benefits[this.benefitIndex].documents = structure;
                    this.benefit.documents = structure;
                    this.empEventName = 'org.benefits.doc.file_delete';
                } else {
                    this.org.extra.offices[this.officeIndex].documents = structure;
                    this.office.documents = structure;
                    this.empEventName = 'org.offices.doc.file_delete';
                }
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

    public safehands_modal(employee: any): void {
        var that = this as any;
        that.medical_files = {};
        that.tmp_emp = {};
        this.bsLoadingOverlayService.start({
            referenceId: 'loader'
        });
        this.Employee.loadEmployee(employee.id)
            .then((employeeResponse: Restangular.IResponse) => {
                that.tmp_emp = employeeResponse;
                if (!that.tmp_emp.extra.employment) {
                    this.employee.extra.employment = {}
                }

                if (!that.tmp_emp.extra.employment.medical_files) {
                    that.tmp_emp.extra.employment.medical_files = {}
                }

                if (!that.tmp_emp.extra.employment.medical_files.cpr_course) {
                    that.tmp_emp.extra.employment.medical_files.cpr_course = []
                }

                if (!that.tmp_emp.extra.employment.medical_files.fit_for_work) {
                    that.tmp_emp.extra.employment.medical_files.fit_for_work = []
                }

                that.medical_files = that.tmp_emp.extra.employment.medical_files;
                this.bsLoadingOverlayService.stop({
                    referenceId: 'loader'
                });

                // TODO: Fix the scoping and put in the right place
                let modalInstance: any = this.$uibModal.open({
                    controller: ['$scope', '$uibModalInstance', 'toaster',
                        function ($scope: any, $uibModalInstance: any, toaster: any): void {
                            $scope.C = that;
                            $scope.medical_files = that.medical_files;
                            $scope.emp_name = that.tmp_emp.displayname;

                            $scope.close = () => {
                                $uibModalInstance.close($scope.confirmation);
                            };
                        }],

                    templateUrl: '/static/templates/modals/safehands_files.html',
                    size: 'lg'
                });

                modalInstance.result.then((result) => {
                    if (result) {
                        this.bsLoadingOverlayService.start({
                            referenceId: 'loader'
                        });

                    } else {
                    }
                });

            });

    }

    public employmentDocumentEdit(index: any): void {
        this.new_logo = false;
        if (index === 'new') {
            this.medicalDocObj = {
                name: this.defaultValue,
                reportDate: this.defaultValue,
                file: this.defaultValue,
                action: 'add'
            };
            this.fileDirModel = {
                fileName: 'Select a file',
                fileLink: undefined
            }
        }
    }

    public documentModalUpload(value: any): void {
        this.new_logo = false;
        this.docObj = {
            number: this.defaultValue,
            expiryDate: this.defaultValue,
            reportDate: this.defaultValue,
            file: this.defaultValue,
            name: this.defaultValue,
            type: this.defaultValue,

        };
    }

    // following function is for converting the bootstrap modals into UIB modals.
    public addEditEmploymentDocuments(): void {
        this.new_logo = false;
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/safe_hands_file_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {
        });
    }

    public saveEmployeeDocumentEdit(model: any): void {
        this.new_logo = false;
        var that = this as any;

        let empDocs: any = that.tmp_emp.extra.employment.medical_files;

        let ldocObj = {
            name: '',
            report_date: '',
            file: '',
        };

        if (model.name !== '') {
            ldocObj.name = model.name;
        }

        if (model.reportDate !== '') {
            ldocObj.report_date = moment(model.reportDate).format('YYYY-MM-DD');
        }

        if (model.file && model.file !== '') {
            ldocObj.file = this.docObj.file;
        }

        if (model.name === 'CPR Course') {
            empDocs.cpr_course.push(ldocObj);
        } else {
            empDocs.fit_for_work.push(ldocObj);
        }

        this.empEventName = 'safehands.health_files.medical_records.add';

        this.bsLoadingOverlayService.start({referenceId: 'loader'});

        that.tmp_emp.put().then((response) => {
                // Check if we need to emit an event log
                if (that.empEventName) {
                    that.emitEvent(that.empEventName, that.empEventAddData);

                    // Reset event data
                    that.empEventName = '';
                    that.empEventAddData = '';
                }
                this.employee = response;
                this.toaster.pop('success', 'Saved');
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            },
            (response: any) => {
                if (response.status === 403) {
                    this.toaster.pop('error', 'Access Denied', response.data.detail);
                } else if (response.status === 400) {
                    this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
                } else {
                    this.toaster.pop('error', 'Server error', 'Please, try again later');
                }
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});

            });
    }

    public uploadDocModalFiles = function (params: any): void {
        const that: any = this;
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let file: any = params.new;
        this.new_logo = false;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                that.docObj.file = response.data.url;
                that.fileDirModel.fileName = that.parseFileName(response.data.url);
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            },
            () => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };



    public toggleTrial() {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        if (!this.org.extra.trial) {
            this.org.extra.trial = {}
        }

        if (this.trialEnabled) {
            this.org.extra.trial.enrolled = true;
            this.org.extra.trial.startOn = moment().format('YYYY-MM-DD');
            this.org.extra.details.employee_can_edit_personal = this.trialEmployeeOwnEdit;
        } else {
            this.org.extra.trial.enrolled = false;
            this.org.extra.trial.endOn= moment().format('YYYY-MM-DD');

            // Disable feature when trial ends
            this.org.extra.details.employee_can_edit_personal = false;
        }

        let url: string = '/api/' + (this.$stateParams['id']
                ? ('orgs/' + this.$stateParams.id)
                : 'org'
        );
        this.$http.put(url, this.Api.stripRestangular(this.org))
            .then((org: any) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.org = org.data;
                this.toaster.pop('success', 'Saved');
                this.$state.reload();
            }, () => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'Server error', 'Please, try again later');
            });


    }
    public isWPSImportStepCompleted(step) {
        return step <= this.wpsImportStep;
    }

    public doIt() {
        this.currentStep++;
    }

    public startImport(): void {
        this.payroll_mode = 1;
        this.wpsImportStep = 1;
    }

    public wpsImportGoBack() {
        this.wpsImportStep -= 1;
    }

    public wpsImportGoFwd() {
        switch (this.wpsImportStep) {
            case 2:
                this.doUpload(true);
                break;
            case 3:
                this.doImport();
                break;
            case 4:
                this.payroll_mode = 0;
                break;
            default:
                this.wpsImportStep += 1;
        }
    }

    public startExport(): void {
        this.payroll_mode = 2;
    }

    public updateWPSFileData(file_data: any) {
        this.wpsFile = file_data;
    }

    public saveWPSExportDates(args) {
        if (args.model == "C.wpsStartDate") {
            this.wpsStartDateStr = args.new;
        } else {
            this.wpsEndDateStr = args.new;
        }
    }

    public doImport() {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.$http.post('/api/org_wps/wps_import_upload_final', null).then((response) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.emitEvent('org.wps_import.upload.final');
                this.toaster.pop('success', 'upload complete', '');
                this.wpsImportStep++;
                this.wpsDone = true;
                this.wpsSuccess = true;
            },
            (response) => {
                this.wpsDone = true;
                this.wpsSuccess = false;
                this.wpsImportStep++;

                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.emitEvent('org.wps_import.upload.final.error');
                if (response.status == 400) {
                    this.toaster.pop('error', 'Import Failed', response.data);
                } else {
                    this.toaster.pop('error', 'Error', response.data);
                }
            }
        );

    }

    public doUpload(preview = true) {
        if (this.wpsFile === undefined || this.wpsFile == null) {
            return
        }


        this.bsLoadingOverlayService.start({referenceId: 'loader'});

        this.Upload.upload({
            url: '/api/org_wps/wps_import_upload',
            method: 'POST',
            data: {file: this.wpsFile}
        }).then(
            (response) => {
                this.emitEvent('org.wps_import.upload');
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('success', 'upload complete', '');
                this.wpsImportData = response.data;

                this.wpsImportStep++;
            },
            (response) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.emitEvent('org.wps_import.upload.error');

                if (response.status == 400) {
                    this.toaster.pop('error', 'Import Failed', response.data);
                } else {
                    this.toaster.pop('error', 'Error', response.data);
                }
            }
        );
    }

    public deleteAllowance(index: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete an allowance';
                    $scope.modalDetail = 'This will delete the defined allowance. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.org.extra.processes.payroll_allowances.splice(index, 1);
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }


    public deleteDeduction(index) {
        this.org.extra.processes.payroll_allowances.pop();
        this.save_page();
    }

    public add_allowance(): void {
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.confirmation = false;
                    $scope.docType = that.defaultValue;
                    $scope.modalHeader = 'Add a New Allowance';
                    $scope.confirmButton = 'Add';
                    $scope.cancelButton = 'Cancel';
                    $scope.saveObj = {};
                    $scope.templateTitle = '';


                    $scope.confirm = () => {
                        if (!that.fix_this_description) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'Please enter in an allowance description'
                            );
                            return;
                        }

                        $scope.confirmation = true;
                        $scope.saveObj = {
                            confirmation: $scope.confirmation,
                            deleting: false,
                            description: that.fix_this_description,
                        };
                        that.fix_this_description = '';
                        $uibModalInstance.close($scope.saveObj);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        that.fix_this_description = '';
                        $uibModalInstance.close($scope.confirmation);
                    };

                }],

            templateUrl: '/static/templates/modals/add_allowance.html'
        });

        modalInstance.result.then(
            (result) => {
                if (result.confirmation) {
                    this.bsLoadingOverlayService.start({
                        referenceId: 'loader'
                    });

                    if (result.deleting === false) {
                        this.org.extra.processes.payroll_allowances.push({
                            description: result.description,
                            id: ''
                        });
                        this.save_page();
                    }
                } else {
                    this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
                }

                this.bsLoadingOverlayService.stop({
                    referenceId: 'loader'
                });
            }
        );
    }

    public add_deduction(isNewDoc: any, docModel?: any, editDocType?: any): any {
        let that: this = this;
        this.new_logo = false;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.C = that;
                    $scope.docModel = undefined;
                    $scope.confirmation = false;
                    $scope.addingDocument = isNewDoc;
                    $scope.docType = that.defaultValue;
                    $scope.modalHeader = (isNewDoc ? 'Add a New Deduction' : 'Delete Document');
                    $scope.confirmButton = isNewDoc ? 'Add' : 'Save';
                    $scope.cancelButton = 'Cancel';
                    $scope.saveObj = {};
                    $scope.templateTitle = '';
                    $scope.allowance_description = 'xx';


                    $scope.confirm = () => {
                        if (!that.fix_this_description) {
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'Please enter in an deduction description'
                            );
                            return;
                        }

                        $scope.confirmation = true;
                        $scope.saveObj = {
                            confirmation: $scope.confirmation,
                            deleting: false,
                            description: that.fix_this_description,
                        };
                        that.fix_this_description = '';
                        $uibModalInstance.close($scope.saveObj);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };

                }],

            templateUrl: '/static/templates/modals/add_allowance.html'
        });

        modalInstance.result.then(
            (result) => {
                if (result.confirmation) {
                    this.bsLoadingOverlayService.start({
                        referenceId: 'loader'
                    });

                    if (result.deleting === false) {
                        this.org.extra.processes.payroll_deductions.push({
                            description: result.description,
                            id: String(this.org.extra.processes.payroll_deductions.length + 1)
                        });
                        this.save_page();
                    }
                } else {
                    this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
                }

                this.bsLoadingOverlayService.stop({
                    referenceId: 'loader'
                });
            }
        );
    }

    public deleteOfficeDocument(officeIndex: any, docIndex: any): void {
        this.new_logo = false;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete document';
                    $scope.modalDetail = 'This will delete the document. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.org.extra.offices[officeIndex].documents.splice(docIndex, 1);
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }

    public deleteOfficeBusinessLicence(officeIndex: any, docIndex: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete business licence';
                    $scope.modalDetail = 'This will delete the business licence. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.org.extra.offices[officeIndex].business_licences.splice(docIndex, 1);
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }

    public deleteOfficeBusinessLicenceFile(officeIndex: any, docIndex: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete business licence file';
                    $scope.modalDetail = 'This will delete the business licence file. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                delete this.org.extra.offices[officeIndex].business_licences[docIndex].file;
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }


    public deleteOfficeDepartment(officeIndex: any, divisionIndex: any, departmentIndex: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete department';
                    $scope.modalDetail = 'This will delete the department. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.org.extra.offices[officeIndex].divisions[divisionIndex].departments.splice(departmentIndex, 1);
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }

    public deleteOfficeDivision(officeIndex: any, divisionIndex: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete division';
                    $scope.modalDetail = 'This will delete the division. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.org.extra.offices[officeIndex].divisions.splice(divisionIndex, 1);
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }

    public deleteOffice(officeIndex: any): void {
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete office';
                    $scope.modalDetail = 'This will delete the office. Are you sure?';
                    $scope.confirmButton = 'Delete';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };

                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.org.extra.offices.splice(officeIndex, 1);
                this.save_page();
            } else {
                this.toaster.pop(
                    'warning',
                    'Cancelled',
                    'No changes were made. Action cancelled by user'
                );
            }
        });
    }


}

angular.module('beneple.orgs')
    .controller('OrganisationDetailController', OrganisationDetailController);
function $q(arg0: (resolve: any, reject: any) => void) {
    throw new Error('Function not implemented.');
}




// WEBPACK FOOTER //
// ./frontend/scripts/organisation/controllers/organisation-detail.controller.ts